import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';

function AssignmentReportDialog({ open, date, plateNumber, comments, onClose, onSubmit, setAssignmentReportDialog, t }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('assignment_report.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('assignment_report.prompt', { date })}
        </DialogContentText>
        <TextField
          fullWidth
          label={t('report.number_plate')}
          value={plateNumber}
          onChange={(e) =>
            setAssignmentReportDialog((prev) => ({ ...prev, plateNumber: e.target.value }))
          }
          margin="normal"
        />
        <TextField
          fullWidth
          label={t('report.comments')}
          value={comments}
          onChange={(e) =>
            setAssignmentReportDialog((prev) => ({ ...prev, comments: e.target.value }))
          }
          multiline
          rows={4}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t('actions.cancel')}
        </Button>
        <Button onClick={onSubmit} color="primary">
          {t('actions.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AssignmentReportDialog;
